import LoadingButton from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { CheckCircleIcon, CirclePlusIcon } from 'components/icons';
import usePromise from 'hooks/usePromise';
import PropTypes from 'prop-types';
import React from 'react';

const CustomButton = React.forwardRef(
  ({ loading, onClick, style, title, ...rest }, ref) => {
    const [isLoading, handler] = usePromise(onClick, loading);

    const props = {
      variant: rest.variant || 'contained',
      color: rest.color || 'primary',
      startIcon: rest.startIcon,
    };

    if (props.startIcon === undefined && typeof rest.children === 'string') {
      // if button text contains "Save" or "Update", use CheckCircleIcon
      const saveMatch = /save|update|ok|submit|confirm/i.test(rest.children);
      if (saveMatch) {
        props.startIcon = <CheckCircleIcon />;
      } else {
        const addMatch = /add|create|new/i.test(rest.children);
        if (addMatch) {
          props.startIcon = <CirclePlusIcon />;
        }
      }
    }

    const component = (
      <LoadingButton
        ref={ref}
        loading={isLoading}
        disabled={isLoading}
        onClick={handler}
        {...props}
        {...rest}
      />
    );

    if (title) {
      return <Tooltip title={title}>{component}</Tooltip>;
    }
    return component;
  },
);

CustomButton.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  variant: PropTypes.string,
  size: PropTypes.oneOfType(['mini', 'small', 'medium', 'large']),
  color: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  focused: PropTypes.bool,
  rounded: PropTypes.bool,
};

export default CustomButton;
